// fetchUserFollowingTotalCount.js
'use strict';
import fetch from '../resource/customFetch.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';

import {
  ADD_LIST_ITEMS,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Fetch user following total count
 * @kind action
 * @param {string} {userId} - user id.
 * @param {object} {[httpProxyHeaders = {}]} - http proxy headers for SSR.
 * @return {Promise} Action promise.
 */
const fetchUserFollowingTotalCount =
  ({ userId, httpProxyHeaders = {} } = {}) =>
  async dispatch => {
    if (!userId) {
      return dispatch({ type: '' });
    }
    const networkingSelectPath = ['fetch', 'user', userId, 'followingCount'];
    const listSelectPath = ['user', userId, 'following'];
    const fetchOptions = {
      method: 'HEAD',
      headers: {
        ...getHeaders(),
        ...httpProxyHeaders,
      },
    };
    const fetchUrl = getResourceUrl({ endpoint: `/users/${userId}/following` });
    dispatch({
      type: SET_NETWORKING_FETCHING,
      payload: { selectPath: networkingSelectPath },
    });
    try {
      let response = await fetch(fetchUrl.href, fetchOptions);
      if (!response.ok) {
        await handleFetchError({ response });
      }
      const totalCount = parseInt(response.headers.get('x-total-count'), 10);
      dispatch({
        type: ADD_LIST_ITEMS,
        payload: {
          selectPath: listSelectPath,
          itemIds: [],
          totalCount,
        },
      });
      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath: networkingSelectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath: networkingSelectPath, error },
      });
    }
  };

export default fetchUserFollowingTotalCount;
